import { EndpointMappings } from 'studiokit-scaffolding-js'
import configuration from './configuration'

const commonQueryParams = configuration.FUNCTION_APP_CODE
	? {
			code: configuration.FUNCTION_APP_CODE
		}
	: undefined

// NOTE: does not use endpointMappings from studiokit-scaffolding-js
const appEndpointMappings: EndpointMappings = {
	getToken: {
		_config: {
			fetch: {
				path: '/token',
				method: 'POST',
				contentType: 'application/x-www-form-urlencoded',
				queryParams: commonQueryParams,
				isAnonymous: true
			}
		}
	},
	// NOTE: match the nested modelName `user.userInfo` to work with studiokit-scaffolding-js
	user: {
		userInfo: {
			_config: {
				fetch: {
					path: '/userInfo',
					queryParams: commonQueryParams
				}
			}
		}
	},
	clientConfig: {
		_config: {
			fetch: {
				path: '/config',
				queryParams: commonQueryParams,
				isAnonymous: true
			}
		}
	},
	usage: {
		_config: {
			fetch: {
				path: '/usage',
				queryParams: commonQueryParams
			}
		}
	},
	convertDocument: {
		_config: {
			fetch: {
				path: '/convert',
				method: 'POST',
				queryParams: commonQueryParams
			}
		}
	},
	describeImage: {
		_config: {
			fetch: {
				path: '/image/describe',
				method: 'POST',
				queryParams: commonQueryParams
			}
		}
	},
	convertImage: {
		_config: {
			fetch: {
				path: '/image/convert',
				method: 'POST',
				queryParams: commonQueryParams
			}
		}
	}
}

export default appEndpointMappings
